export default function pad(n) {
  return ('00' + n).slice(-2)
}
